import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiUrl, SWAApiUrlProvider } from '../utility/api-config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
// tslint:disable-next-line: jsdoc-format
/**Api service call for Crewbid App */
export class CrewbidApiService {
  constructor(private http: HttpClient) {}

  /**
   * @method GetRestDataForGet get request
   * @param serviceNameandParameter (Service name and parameter as string)
   */

  public GetRestDataForGet(serviceNameandParameter: string): Observable<any> {
    return this.http.get<any>(ApiUrl + serviceNameandParameter, {
      withCredentials: true,
    });
  }

  /**
   * @method GetRestDataForPost post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */

  public GetRestDataForPost(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
    return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
      withCredentials: true,
    });
  }

  /**
   * @method GetRestDataForPost post request with progress indication
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */
  GetRestDataForPostWithProgress(serviceNameandParameter: string, jsonString: any) {
    return this.http.post(ApiUrl + serviceNameandParameter, jsonString, {
      withCredentials: true,
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * @method AsyncGetRestDataForPost async post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */
  public async AsyncGetRestDataForPost(
    serviceNameandParameter: string,
    jsonString: any
  ): Promise<any> {
    const rsp = await this.http
      .post<any>(ApiUrl + serviceNameandParameter, jsonString, {
        withCredentials: true,
      })
      .toPromise();
    return rsp;
  }

  public paypalPayment(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
      const ApiUrl = 'https://www.crewbid-wbidmax.com/PayPalWebHook/';
      return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
      responseType: 'json',
    });
  }

  public stripePayment(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
      const ApiUrl = 'https://www.crewbid-wbidmax.com/StripeWebHook/';
      return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
      responseType: 'json',
    });
  }

    /**
   * @method GetStripePaymentStatus for fetching the vacation data
   * @returns status as string
   */
    public GetStripePaymentStatus(invoiceId: string): Observable<any> {
          const ApiUrl = 'https://www.crewbid-wbidmax.com/StripeWebHook/api/StripePayWebHook/GetStripePaymentStatus?invoiceId=' + invoiceId;
          return this.http.get<any>(ApiUrl, {
          responseType: 'text' as 'json',
        });
    }
  
  /**
   * @method SWAGetData get request
   * @param serviceNameandParameter (Service name and parameter as string)
   */
  public SWAGetData(servicePathOrFullUrl: string): Observable<any> {
    const isFullUrl = servicePathOrFullUrl.startsWith('http://') || servicePathOrFullUrl.startsWith('https://');
    const finalUrl = isFullUrl
      ? servicePathOrFullUrl
      : SWAApiUrlProvider.SWAapiUrl + servicePathOrFullUrl;

    return this.http.get<any>(finalUrl, {
      withCredentials: true,
    });
  }

  /**
   * @method SWAPostData post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */
  public SWAPostData(
    serviceNameandParameter: string,
    jsonString: any
  ): Observable<any> {
    return this.http.post<any>(SWAApiUrlProvider.SWAapiUrl + serviceNameandParameter, jsonString, {
      withCredentials: true,
    });
  }

  /**
   * @method SWAGetToken for get PKCE token from SWA 
   */
  public SWAGetToken(
    serviceNameandParameter: string,
    body: any,
    headers: any
  ): Observable<any> {
    return this.http.post<any>(SWAApiUrlProvider.SWAOauthUrl + serviceNameandParameter, body, { headers });
  }

  /**
  * @method GetRestDataForGetSWAPdf for get PDF files from SWA server
  */
  public GetRestDataForGetSWAPdf(serviceNameandParameter: string): Observable<Blob> {
    return this.http.get(SWAApiUrlProvider.SWAapiUrl + serviceNameandParameter, {
      responseType: 'blob',
      withCredentials: true
    });
  }

}
